import { styled } from '../../../../../../../core/theme/styled';

export const MultiImageContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
`;

export const SelectableImage = styled.div`
  label {
    display: flex;
    position: relative;
    border: none;
    border-radius: 0.5rem;
    box-shadow: 0 0 0 3px transparent;
    outline: 3px solid transparent;
    transition: 0.1s;
    height: 100%;
    z-index: 0;

    &:has(input:focus) {
      box-shadow: 0 0 10px 3px ${(props) => props.theme.configuration.primaryColor};
    }
    &:has(input:checked) {
      outline-color: ${(props) => props.theme.configuration.primaryColor};
    }

    input[type='checkbox'],
    input[type='radio'] {
      position: absolute;
      width: 100%;
      height: 100%;
      opacity: 0;
      z-index: 1;
      cursor: pointer;
    }
  }
  img {
    max-width: 100%;
    border-radius: ${(props) => props.theme.sizes.xxsmall};
    object-fit: contain;
    z-index: 0;
  }
`;
